import { render, staticRenderFns } from "./_BaseHeaderButton.vue?vue&type=template&id=9f4c5426"
import script from "./_BaseHeaderButton.vue?vue&type=script&lang=js"
export * from "./_BaseHeaderButton.vue?vue&type=script&lang=js"
import style0 from "./_BaseHeaderButton.vue?vue&type=style&index=0&id=9f4c5426&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports